<div class="social-login" *ngIf="isLoaded">
    <span class="mb-1">Or</span>
    <div class="external-link"><cm-google-id-provider (callback)="googleCallback($event)"></cm-google-id-provider></div>
    <ng-container *ngIf="settings">
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.ONE_LOGIN]?.enabled">
            <button class="btn one-login-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.ONE_LOGIN)">
                <span class="one-login-icon"
                    >Login with {{ settings[SIGN_IN_TYPES.ONE_LOGIN].loginProviderName || 'onelogin' }}</span
                >
            </button>
        </div>
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.OKTA]?.enabled">
            <button class="btn okta-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.OKTA)">
                <span class="okta-icon">Login with {{ settings[SIGN_IN_TYPES.OKTA].loginProviderName || 'okta' }}</span>
            </button>
        </div>
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.AZURE]?.enabled">
            <button class="btn azure-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.AZURE)">
                <span class="azure-icon"
                    >Login with {{ settings[SIGN_IN_TYPES.AZURE].loginProviderName || 'azure' }}</span
                >
            </button>
        </div>
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.AZURE_SAML]?.enabled">
            <button class="btn azure-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.AZURE_SAML)">
                <span class="azure-icon"
                    >Login with {{ settings[SIGN_IN_TYPES.AZURE_SAML].loginProviderName || 'azure SAML' }}</span
                >
            </button>
        </div>
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.ENTRA]?.enabled">
            <button class="btn entra-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.ENTRA)">
                <span class="entra-icon"
                    >Login with {{ settings[SIGN_IN_TYPES.ENTRA].loginProviderName || 'entra' }}</span
                >
            </button>
        </div>
        <div class="external-link" *ngIf="settings[SIGN_IN_TYPES.PING]?.enabled">
            <button class="btn ping-btn" type="button" (click)="extProviderClick(SIGN_IN_TYPES.PING)">
                <span class="ping-icon">Login with {{ settings[SIGN_IN_TYPES.PING].loginProviderName || 'ping' }}</span>
            </button>
        </div>
    </ng-container>
</div>
